@if (show) {
<!-- <mat-progress-bar [mode]="mode" [value]="progress"></mat-progress-bar> -->
<div
    class="fixed inset-0 z-[2000] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm transition-opacity duration-150 opacity-100">
    <mat-progress-spinner mode="indeterminate"
        diameter="48"></mat-progress-spinner>
</div>
}